export default "__VITE_ASSET__DJzU8aPZ__"